module.exports = __webpack_public_path__ + "img/cargatjt.7afb4e8c.png";